import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <a href="#top" className="footer-logo">
        <span>TAG</span><span>pdf</span>
      </a>
      <div className="footer-links">
        <a href="https://github.com/vijay4dev"           target="_blank" rel="noreferrer">GitHub</a>
        <a href="https://x.com/brrocode"                 target="_blank" rel="noreferrer">@brrocode</a>
        <a href="https://brrocodeportfolio.online/"       target="_blank" rel="noreferrer">Portfolio</a>
      </div>
      <div className="footer-note">Built with care. Private by design.</div>
    </footer>
  );
}
